/* eslint max-classes-per-file: ["error", 5] */

import config from '../config';
import {
  MAX_REMOTE_OPPOSITE_NUM,
  PAINT_COLORS,
  REMOTE_MEMBER_TYPE,
  SEND_FILE_COMMANDS,
  TLVX_COMMANDS,
  TLVX_LIGHT_COMMANDS,
  TLVX_RECEIVE_COMMANDS,
  ADJUST_SCREEN_COMMANDS,
} from './constants';
import { consoleNormalLog, convertToBase64, sleep } from './tools';

// safari向け
window.AudioContext = window.AudioContext || window.webkitAudioContext;

/* eslint-disable */
if (
  navigator.userAgent.toLocaleLowerCase().indexOf('chrome') === -1 &&
  navigator.userAgent.match(/AppleWebKit\/(\d+)\./)
) {
  var intervals = {};
  var orgSetInterval = window.setInterval;

  function createTimer(set, map, args) {
    var id,
      cb = args[0];
    function callback() {
      if (cb) {
        cb.apply(window, arguments);
      }
    }
    args[0] = callback;
    id = set.apply(window, args);
    map[id] = { args: args, created: Date.now(), cb: cb, id: id };
    return id;
  }

  window.setInterval = function () {
    return createTimer(orgSetInterval, intervals, arguments);
  };
}
/* eslint-enable */

const { OMP, SampleApp, AudioContext } = global;
const { roomServerWebSockURL } = config;
const mixColorCanvasName = '#mix_color_canvas';

let namesDef = null;
let websockEnv;
let mediaStreamLocal;
let mediaStreamForUpStream;
let videoManager;
let canvasManager;
const initialIndex = 0;
let currentVideoSharerIndex = 0;
let gOmpAudioEnabled = true;
let targetManager;
let audioContext = null;
// let audioMixer;
let videoTrackMuter;
let webSockKeepAliveRequester;
let localVideoCanvasControl;

let hasCameraDevice = false;
let hasMicDevice = false;

/**
 * クライアントキャンバスのindexを設定する.
 * 引数が「-1」の場合は「0」を設定する. 「0」の場合は自身がオペレータでクライアント未決定の状態
 */
const setClientCanvasIndex = clientIndex => {
  currentVideoSharerIndex = clientIndex < 0 ? 0 : clientIndex;
};

/**
 * クライアントのcanvasを表示する
 */
const switchRemoteCanvas = () => {
  for (let i = 1; i <= MAX_REMOTE_OPPOSITE_NUM; i += 1) {
    const targetElementId = `remote${i}_chatBox`;
    const target = document.getElementById(targetElementId);

    if (i === currentVideoSharerIndex) {
      target.style.display = 'flex';
    } else {
      target.style.display = 'none';
    }
  }
};

/** 共有者変更処理 */
const switchSharer = clientIndex => {
  // console.log('switchSharer=', clientIndex);
  const oldClientCanvasIndex = currentVideoSharerIndex;
  setClientCanvasIndex(clientIndex);

  if (
    oldClientCanvasIndex !== currentVideoSharerIndex &&
    currentVideoSharerIndex !== 0
  ) {
    canvasManager.startNopAll();
    targetManager.setTargetIndex(currentVideoSharerIndex);
  }
  switchRemoteCanvas();
};

// 入室情報通知受信処理
class SoraIncomingHandler {
  constructor(dispatch) {
    this.dispatch = dispatch;
  }

  handle(notify) {
    const incoming = notify;
    const participantId = incoming.incoming_participant.pid;
    this.dispatch({ type: 'RECEIVED_ROOM_INCOMING_INFO', participantId });
    return true;
  }
}

// 退室情報受信処理
class SoraOutgoingHandler {
  constructor(dispatch) {
    this.dispatch = dispatch;
  }

  handle(notify) {
    const outgoing = notify;
    const participantId = outgoing.outgoing_participant.pid;
    this.dispatch({ type: 'RECEIVED_ROOM_OUTGOING_INFO', participantId });
    return true;
  }
}

/** データ受信 */
let participantIdForSet = '';
class DataReceiver {
  constructor(dispatch) {
    this.dispatch = dispatch;
  }

  /** TLVXデータ受信処理 */
  receiveData(from, kind, data) {
    // 取得したdataをstringに変換
    const message =
      OMP.Room.Protocol.DataTransferDataConvertor.convertToString(data);
    consoleNormalLog(
      `[**receiveData**]from:${from},kind:${kind},message:${message}`,
    );
    switch (kind) {
      // クライアント側から映像共有開始(すでに共有者がいる場合、入室前でも受信する)
      case TLVX_RECEIVE_COMMANDS.startSharing: {
        // 取得したfromを映像共有者としてstateに保存
        this.dispatch({
          type: 'RECEIVED_CHANGE_VIDEO_SHARER',
          participantId: from,
        });
        // videoManagerからcanvasのindexを特定し、設定する
        // console.log(videoManager.videos);
        const clientIndex = videoManager.videos.findIndex(
          videoElm =>
            from &&
            videoElm &&
            videoElm.user &&
            videoElm.user.participant_id === from,
        );
        if (clientIndex === -1) {
          // 入室前はindexが取得できないため入室時に設定させる
          participantIdForSet = from;
        } else {
          switchSharer(clientIndex);
        }
        break;
      }
      // クライアント側からの映像共有停止
      case TLVX_RECEIVE_COMMANDS.endSharing: {
        // 映像共有者を解除する
        this.dispatch({ type: 'RECEIVED_CLEAR_VIDEO_SHARER' });
        // canvasのindexを初期化
        switchSharer(0);
        break;
      }
      // videoモードに変更
      case TLVX_COMMANDS.setCameraTransMode: {
        this.dispatch({ type: 'RECEIVED_TOGGLE_TRANS_MODE', isVideo: true });
        break;
      }
      // 画面キャプチャモードに変更
      case TLVX_COMMANDS.setVideoCaptureMode: {
        this.dispatch({ type: 'RECEIVED_TOGGLE_TRANS_MODE', isVideo: false });
        break;
      }
      // ライトON
      case TLVX_LIGHT_COMMANDS.on: {
        this.dispatch({ type: 'RECEIVED_TOGGLE_LIGHT', isLight: true });
        break;
      }
      // ライトOFF
      case TLVX_LIGHT_COMMANDS.off: {
        this.dispatch({ type: 'RECEIVED_TOGGLE_LIGHT', isLight: false });
        break;
      }
      // 一時停止
      case ADJUST_SCREEN_COMMANDS.pause: {
        this.dispatch({ type: 'RECEIVED_TOGGLE_PAUSE', isPause: true });
        break;
      }
      // 一時停止を再開
      case ADJUST_SCREEN_COMMANDS.resume: {
        this.dispatch({ type: 'RECEIVED_TOGGLE_PAUSE', isPause: false });
        break;
      }
      default: {
        break;
      }
    }
  }
}

// 動画サイズにCanvasサイズを合わせる
const initialExpansionValue = 1;
let expansionValue = initialExpansionValue;
export const setExpansionValue = value => {
  expansionValue = value;
};
export const resetExpansionValue = () => {
  expansionValue = initialExpansionValue;
};

const drawVideoToCanvas = (obj, type) => {
  const minWidth = 0;
  const { frameRate } = obj;
  const cursorCanvas = document.getElementById(`${type}_cursor`);
  const canvas = document.getElementById(`${type}_canvas`);
  const chatBox = document.getElementById(`${type}_chatBox`);
  const video = document.getElementById(`${type}_video`);
  setInterval(() => {
    const aspect = video.videoHeight / video.videoWidth;
    const isOver = chatBox.clientWidth * aspect > chatBox.clientHeight;
    canvas.width = minWidth;
    canvas.height = minWidth * aspect;
    if (isOver) {
      canvas.width = (chatBox.clientHeight * expansionValue) / aspect;
      canvas.height = chatBox.clientHeight * expansionValue;
    } else {
      canvas.width = chatBox.clientWidth * expansionValue;
      canvas.height = chatBox.clientWidth * aspect * expansionValue;
    }
    const context = canvas.getContext('2d');
    const videoEnabled = video.srcObject !== null;
    if (videoEnabled) {
      video.width = canvas.width;
      video.height = canvas.height;
      context.drawImage(video, 0, 0, canvas.width, canvas.height);
      if (type === 'local') {
        const localPaintCanvasArray = obj.local_paint_canvas_array;
        localPaintCanvasArray.map(
          localPaintCanvas =>
            context.drawImage(
              localPaintCanvas,
              0,
              0,
              canvas.width,
              canvas.height,
            ), // 赤ペンを重ねる
        );
        context.drawImage(cursorCanvas, 0, 0, canvas.width, canvas.height); // 指差しを重ねる
      }
    } else {
      context.clearRect(0, 0, canvas.width, canvas.height);
    }
  }, 1000 / frameRate);
};

const setupVideoCanvas = () => {
  const controls = OMP.Room.Video.VideoCanvasControlArrayBuilder.build(
    namesDef.getNameSetArray(),
    namesDef.getLocalPaintCanvasNameArray(),
  );
  controls.forEach((control, index) => {
    if (index === 0) {
      // ローカルのcanvas初期設定、描画開始処理など
      localVideoCanvasControl = control;
      // control.hideVideo(); // 内部で none 化するので、使っていたらコメントアウトする。
      control.hideCursor();
      control.hidePaint();
      control.showCanvas();
      // control.drawVideoToCanvas();
      drawVideoToCanvas(control, 'local');
    } else {
      // remote側処理
      control.hideCanvas();
      control.hideCursor();
      control.hidePaint();
      control.showVideo();
      drawVideoToCanvas(control, `remote${index}`);
    }
  });
};

// KeepAlive を定期的に送信する。
export const startKeepAlive = roomInfo => {
  webSockKeepAliveRequester.bindWebSockEnvironment(websockEnv);
  webSockKeepAliveRequester.setConnectionInfo(
    new OMP.Room.ConnectionInfo(roomInfo.roomId, roomInfo.participantId, [
      roomInfo.participantId,
    ]),
  );
  webSockKeepAliveRequester.sendKeepAliveCyclic();
};

// ルーム入室処理
export const enterRoom = (dispatch, roomEntranceInfo, clientInfo) => {
  consoleNormalLog(
    `[**enterRoom**]roomid:${roomEntranceInfo.roomId},clientInfo=${clientInfo}`,
  );
  const { roomId, participantId, token, memberType } = roomEntranceInfo;
  const { normalSupport } = clientInfo;
  // const isMultistream = true;
  gOmpAudioEnabled = true;

  const cursorCanvasNameArray = namesDef.getCursorCanvasNameArray();
  const paintCanvasNameArray = namesDef.getPaintCanvasNameArray();
  const localPaintCanvasNameArray = namesDef.getLocalPaintCanvasNameArray();
  const paintManager =
    new OMP.Room.Protocol.Manager.MultiCanvasLocalPaintManager(
      videoManager,
      paintCanvasNameArray,
      localPaintCanvasNameArray,
      mixColorCanvasName,
      0.3,
    );
  paintManager.bindWebSockEnvironment(websockEnv);

  const stickerManager =
    new OMP.Room.Protocol.Manager.MultiCanvasLocalStickerManager(
      videoManager,
      cursorCanvasNameArray,
    );
  stickerManager.bindWebSockEnvironment(websockEnv);

  const remoteControlManager =
    new OMP.Room.Protocol.Manager.MultiCanvasLocalRemoteControlManager(
      videoManager,
      paintCanvasNameArray,
    );
  remoteControlManager.bindWebSockEnvironment(websockEnv);

  const videoParam = new OMP.Sora.VideoParameter('VP8', 500);
  const audioParam = new OMP.Sora.AudioParameter('OPUS', 64);

  // const incomingHandler = new SampleApp.SoraIncomingHandler(
  //   videoManager,
  //   videoParam,
  //   audioParam,
  //   'incoming',
  //   isMultistream,
  // );
  const incomingHandler = new SoraIncomingHandler(dispatch);
  const outgoingHandler = new SoraOutgoingHandler(dispatch);

  // const dataViewer = new OMP.Room.Protocol.HtmlTextAreaDataTransferDataViewer(
  //   '#data_transfer_data_text_area',
  // );
  // const dataAdapter = new OMP.Room.Protocol.DataTransferDataAdapter(dataViewer);
  const dataAdapter = new DataReceiver(dispatch);

  const receiver = new OMP.Room.Protocol.ProtocolReceiver(
    paintManager,
    stickerManager,
    remoteControlManager,
    incomingHandler,
    videoManager,
    dataAdapter,
    outgoingHandler,
  );
  const manager = videoManager;

  targetManager.setRoomID(roomId);
  targetManager.setSourceParticipantID(participantId);

  targetManager.setTargetIndex(initialIndex);
  switchSharer(initialIndex);

  // Video を無効にした場合、ローカルCanvasへの描画も止める。
  if (memberType === REMOTE_MEMBER_TYPE.operator && hasCameraDevice) {
    // リモート側なのでローカルキャンバスの描画を停止
    localVideoCanvasControl.videoDrawDisable();
  }

  websockEnv.websock.close().then(() => {
    websockEnv.reconstruct();
    websockEnv.websock
      .waitToOpen()
      .then(() => {
        OMP.Misc.roomServerRoomEnter(
          mediaStreamForUpStream,
          websockEnv,
          videoParam,
          audioParam,
          roomId,
          participantId,
          token,
          receiver,
          manager,
          true /* is_multistream */,
        )
          .then(() => {
            startKeepAlive(roomEntranceInfo);
            if (normalSupport) {
              switchSharer(1); // 通常支援の場合はindexは1固定
            } else if (participantIdForSet) {
              // 共有相手がすでに決定している場合(途中参加の場合)
              const clientIndex = participantIdForSet
                ? manager.videos.findIndex(
                    videoElm =>
                      videoElm.user &&
                      videoElm.user.participant_id === participantIdForSet,
                  )
                : 0;
              switchSharer(clientIndex);
              consoleNormalLog(
                `[**enterRoom**]multi remote call,set index:${clientIndex}`,
              );
            }
          })
          .catch(() => {
            consoleNormalLog(
              '[**enterRoom:ERROR**]OMP.Misc.roomServerRoomEnter',
            );
          });
      })
      .catch(() => {
        consoleNormalLog('[**enterRoom:ERROR**]websockEnv.websock.waitToOpen');
      });
  });
};

export const getPaintBorderWidth = () => {
  const paintBorderWidth = 15;
  return paintBorderWidth;
};

export const paintStart = colorIndex => {
  if (currentVideoSharerIndex === 0) {
    return;
  }
  // 設定はしているが、アプリでコントロールするらしい
  const paintColor = `${PAINT_COLORS[colorIndex || 0]}FF`;
  const borderWidth = getPaintBorderWidth();
  canvasManager.startNopAll();
  canvasManager.startPaint(currentVideoSharerIndex, paintColor, borderWidth);
};
export const paintStop = () => {
  canvasManager.startNopAll();
};

export const paintAllClear = () => {
  if (currentVideoSharerIndex === 0) {
    return;
  }
  canvasManager.clearAllPaint(currentVideoSharerIndex);
  canvasManager.hideSticker(currentVideoSharerIndex);
  canvasManager.startNopAll();
};

export const stickerStart = () => {
  if (currentVideoSharerIndex === 0) {
    return;
  }
  canvasManager.startNopAll();
  canvasManager.startSticker(currentVideoSharerIndex);
};

export const stickerHide = () => {
  if (currentVideoSharerIndex === 0) {
    return;
  }
  canvasManager.hideSticker(currentVideoSharerIndex);
  canvasManager.startNopAll();
};

export const remoteControlStart = () => {
  if (currentVideoSharerIndex === 0) {
    return;
  }
  canvasManager.startRemoteControl(currentVideoSharerIndex);
};

export const remoteControlEnd = () => {
  const info = targetManager.buildConnectionInfo();
  const remoteControlManager =
    new OMP.Room.Protocol.Manager.RemoteRemoteControlManager(websockEnv, info);
  remoteControlManager.controlEnd();
  canvasManager.startNopAll();
};

/**
 * チャット文字列送信(送信ボタンを押した時に送信する)
 * dataTransferManager.sendString内でkind=1として送信する
 */
export const dataSend = value => {
  if (currentVideoSharerIndex === 0) {
    return;
  }
  const dataTransferManager =
    new OMP.Room.Protocol.Manager.UTF8StringDataTransferManager(
      websockEnv,
      targetManager,
    );
  dataTransferManager.sendString(value);
};

/**
 * TLVXデータ送信(現在の映像共有者(currentVideoSharerIndex)が送信対象)
 */
export const sendDataCurrentTarget = (kind, data) => {
  // dataの変換
  const dataToSend =
    OMP.Room.Protocol.DataTransferDataConvertor.convertFromString(data);
  const dataTransferManager =
    new OMP.Room.Protocol.Manager.UTF8StringDataTransferManager(
      websockEnv,
      targetManager,
    );
  dataTransferManager.send(kind, dataToSend);
};
/**
 * TLVXデータ送信（指定したユーザ対象）
 * @param kind 送信種別
 * @param data 送信内容
 * @param participantId 送信相手
 */
export const sendDataSpecifiedMember = (kind, data, participantId) => {
  // dataの変換
  const dataToSend =
    OMP.Room.Protocol.DataTransferDataConvertor.convertFromString(data);
  // 該当するユーザにTLVXデータ送信を行う
  videoManager.videos.forEach((videoElm, index) => {
    // 送信処理
    if (
      videoElm.is_assigned &&
      videoElm.user &&
      videoElm.user.participant_id === participantId
    ) {
      consoleNormalLog(
        `[**sendDataSpecifiedMember**]send:${index},${videoElm.user.participant_id}`,
      );
      // 送信対象のindexを設定
      targetManager.setTargetIndex(index);
      const dataTransferManager =
        new OMP.Room.Protocol.Manager.UTF8StringDataTransferManager(
          websockEnv,
          targetManager,
        );
      dataTransferManager.send(kind, dataToSend);
    }
  });
  // targetManagerのindexを必ず戻す
  targetManager.setTargetIndex(currentVideoSharerIndex);
};
/**
 * TLVXデータ送信（入室している通信相手全員）
 * @param kind 送信種別
 * @param data 送信内容
 * @param includeMe 自身に対しても送信する場合はtrue
 */
export const sendDataJoinedMembers = (kind, data, includeMe = false) => {
  // dataの変換
  const dataToSend =
    OMP.Room.Protocol.DataTransferDataConvertor.convertFromString(data);
  // 有効なユーザにTLVXデータ送信を行う
  videoManager.videos.forEach((videoElm, index) => {
    // 送信処理
    if (
      (includeMe || index !== 0) &&
      videoElm.is_assigned &&
      videoElm.user &&
      videoElm.user.participant_id
    ) {
      // 入室済みユーザ全員に対して送信する。自身はincludeMeフラグに従う。
      consoleNormalLog(
        `[**sendDataJoinedMembers**]send:${index},${videoElm.user.participant_id}`,
      );
      // 送信対象のindexを設定
      targetManager.setTargetIndex(index);
      const dataTransferManager =
        new OMP.Room.Protocol.Manager.UTF8StringDataTransferManager(
          websockEnv,
          targetManager,
        );
      dataTransferManager.send(kind, dataToSend);
    }
  });
  // targetManagerのindexを必ず戻す
  targetManager.setTargetIndex(currentVideoSharerIndex);
};

/**
 * TLVXデータ送信を利用して現在の映像共有者にファイルデータを送信する
 * @param splitData 送信内容
 * @param splitLength 分割サイズ[byte]、省略時は固定8000byte
 * @param sendInterval 分割送信の間隔[ms]、省略時は固定15ms
 */
export const sendFileDataCurrentTarget = async (
  file,
  splitLength = 8000,
  sendInterval = 15,
) => {
  await convertToBase64(file).then(async result => {
    const base64 = result.substring(result.indexOf('base64,') + 7);
    const reg = new RegExp(`.{1,${splitLength}}`, 'g');
    const splitData = base64.match(reg);

    // 送信開始コマンドを送信
    const sendFileParams = {
      number: splitData.length,
      name: file.name,
      type: file.type,
    };
    sendDataCurrentTarget(
      SEND_FILE_COMMANDS.start,
      JSON.stringify(sendFileParams),
    );
    splitData.forEach(async data => {
      await sendDataCurrentTarget(SEND_FILE_COMMANDS.data, data);
      await sleep(sendInterval);
    });
    // 送信終了コマンドを送信
    sendDataCurrentTarget(SEND_FILE_COMMANDS.end);
  });
};

// オペレータ側のマイクのON/OFF
export const toggleSound = () => {
  const audioTrack = mediaStreamForUpStream.getAudioTracks();
  if (audioTrack && audioTrack[0]) {
    audioTrack[0].enabled = !audioTrack[0].enabled;
  }
};

const bindLocalMediaStream = () => {
  const localVideo = document.querySelector('#local_video');
  const localAudio = document.querySelector('#local_audio');
  const video = new OMP.Room.Video.VideoElementManager(localVideo, localAudio);
  video.bindMediaStream(mediaStreamLocal);
  video.muteAudio();
  setupVideoCanvas();
};

const bindUpStream = isOperator => {
  if (audioContext) {
    audioContext.close();
  }
  audioContext = new AudioContext();
  if (isOperator) {
    const videoAudioStream2 =
      OMP.Room.Stream.MediaStreamBuilder.buildEmptyVideo(
        audioContext,
        audioContext.createMediaStreamDestination(),
        mediaStreamLocal,
        gOmpAudioEnabled,
      );
    mediaStreamForUpStream = videoAudioStream2;
    // マイクをデフォルトオフにする場合
    // const audioTrack = mediaStreamForUpStream.getAudioTracks();
    // if (audioTrack && audioTrack[0]) {
    //   audioTrack[0].enabled = false;
    // }
  } else {
    // WEBはクライアントにならないためコメントアウト
    // // canvasのcaptureStreamを作成
    // const localCanvas = document.querySelector('#local_canvas');
    // const capStream = localCanvas.captureStream(15); // 15 FPS
    // // dummyCanvasを作成
    // const blackCanvas = OMP.Room.Stream.DummyBlackVideoCanvasBuilder.build(1, 1);
    // const dummyStream = blackCanvas.captureStream(15);
    // // 音声を付加する。
    // audioMixer = new OMP.Room.Stream.Audio.OscillatorAudioMixer(mediaStreamLocal);
    // const videoAudioStream = OMP.Room.Stream.MediaStreamBuilder.buildUseAudioMixer(
    //   audioMixer,
    //   audioContext,
    //   audioContext.createMediaStreamDestination(),
    //   capStream,
    //   dummyStream,
    //   true,
    //   gOmpAudioEnabled,
    // );
    // audioMixer.getAudioGainControl().oscillatorStart();
    // audioMixer.getAudioGainControl().mic1On();
    // mediaStreamForUpStream = videoAudioStream;
  }
};

const getMicDevice = () =>
  new Promise(resolve => {
    const micDevice = new OMP.RTC.UpStreamMediaDevice({
      video: false,
      audio: true,
    });
    micDevice
      .getUserMedia()
      .then(streamTmp => {
        streamTmp.getAudioTracks()[0].stop();
        resolve(true);
      })
      .catch(err => {
        const message = err && err.message;
        consoleNormalLog(`[**getMicDevice**]no mic:${message}`);
        resolve(false);
      });
  });

const getCameraDevice = () =>
  new Promise(resolve => {
    // リアカメラ要求 タブレットのみにしたい
    // const medias = {
    //   audio: false,
    //   video: {
    //     facingMode: {
    //       exact: 'environment',
    //     },
    //   },
    // };

    const cameraDevice = new OMP.RTC.UpStreamMediaDevice({
      audio: false,
      video: true,
    });
    cameraDevice
      .getUserMedia()
      .then(streamTmp => {
        streamTmp.getVideoTracks()[0].stop();
        resolve(true);
      })
      .catch(err => {
        const message = err && err.message;
        consoleNormalLog(`[**getCameraDevice**]no camera:${message}`);
        resolve(false);
      });
  });

/**
 * 遠隔支援開始初期化処理
 * @param {*} memberType 1:client/2:operator
 * @param {*} cb callback function
 */
export const initialDevice = async (memberType, cb) => {
  consoleNormalLog(`[**initialDevice:START**]memberType:${memberType}`);

  // クライアント用1つとオペレータ用9つのcanvasを作成
  const videoCanvasArray = [
    // eslint-disable-next-line new-cap
    new SampleApp.VideoCanvasNameSetBuilder.buildLocalCanvasNameSet(),
  ]; // eslint-disable-line
  const localPaintCanvasNameArray = ['#local_paint'];
  for (let i = 1; i <= MAX_REMOTE_OPPOSITE_NUM; i += 1) {
    videoCanvasArray.push(
      new SampleApp.VideoCanvasNameSetBuilder.buildRemoteCanvasNameSet(i), // eslint-disable-line
    );
    localPaintCanvasNameArray.push(`#local_paint${i}`);
  }
  namesDef = new OMP.Room.Video.VideoCanvasNameSetArray(
    videoCanvasArray,
    new OMP.Room.Video.LocalPaintCanvasNameSet(localPaintCanvasNameArray),
  );

  // マイクチェック
  hasMicDevice = await getMicDevice();
  if (!hasMicDevice) {
    // マイクが見つからない場合はエラー
    mediaStreamForUpStream = new MediaStream();
    cb(false);
    return;
  }

  const isOperator = memberType === REMOTE_MEMBER_TYPE.operator;
  if (!isOperator) {
    // クライアントはカメラチェック
    hasCameraDevice = await getCameraDevice();
  }

  const device = new OMP.RTC.UpStreamMediaDevice({
    video: hasCameraDevice,
    audio: hasMicDevice,
  });
  device
    .getUserMedia()
    .then(mediaStream => {
      mediaStreamLocal = mediaStream;
      bindLocalMediaStream();
      bindUpStream(isOperator);
      videoTrackMuter = new OMP.Room.Stream.Video.VideoTrackMuter();
      videoTrackMuter.bindStream(mediaStreamLocal);
      cb(true);
    })
    .catch(err => {
      const message = (err && err.message) || 'No messages';
      consoleNormalLog(`[**initialDevice:ERROR**]get user media:${message}`);
      // デバイスの準備に失敗
      mediaStreamForUpStream = new MediaStream();
      hasCameraDevice = false;
      hasMicDevice = false;
      cb(false);
    });

  const videoManagerDebug = process.env.NODE_ENV === 'development';
  videoManager = OMP.Room.Video.VideoManagerBuilder.build(
    document,
    namesDef.getVideoNameArray(),
    namesDef.getAudioNameArray(),
    videoManagerDebug,
  );

  // WebSocket のオープン。
  websockEnv = new OMP.Room.MsgPackWebSockEnvironment(roomServerWebSockURL);
  websockEnv.websock.waitToOpen().then(() => {});

  canvasManager = OMP.Room.Canvas.RemoteCanvasManagerBuilder.build(
    websockEnv,
    namesDef.getCursorCanvasNameArray(),
    namesDef.getPaintCanvasNameArray(),
    namesDef.getCanvasNameArray(),
    namesDef.getVideoNameArray(),
    true,
    mixColorCanvasName,
  );

  targetManager = new OMP.Room.Protocol.ProtocolTargetManager(videoManager); // らくがき先
  canvasManager.bindProtocolTargetManager(targetManager);
  webSockKeepAliveRequester = new OMP.Room.Protocol.WebSockKeepAliveRequester();
};

// 退室処理
export const exitRoom = () => {
  websockEnv.disconnect();
};

export default dataSend;
